module.exports = __webpack_public_path__ + "static/media/additionalDetailsPage.a487fd62.jpg";